var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1578",
    "data-name": "Rectangle 1578",
    width: 58,
    height: 58,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_738",
    "data-name": "Groupe 738",
    transform: "translate(0.386 0.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_729",
    "data-name": "Groupe 729",
    transform: "translate(-0.386 -0.386)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4647",
    "data-name": "Trac\\xE9 4647",
    d: "M58.637,30.568A28.069,28.069,0,1,1,30.568,2.5,28.069,28.069,0,0,1,58.637,30.568",
    transform: "translate(-1.344 -1.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4648",
    "data-name": "Trac\\xE9 4648",
    d: "M74.627,51.927H73.181c0-.962,0-1.926,0-2.891s0-.953-.86-.953c-.156,0-.312,0-.468,0-.533-.022-.728-.232-.8-.82-.877-6.908-4.223-11.6-10.184-13.7-7.874-2.783-16.405,2.971-18.014,12.014-.1.574-.174,1.155-.249,1.734-.068.523-.276.753-.755.774-.34.015-.682.018-1.022,0-.259-.014-.35.1-.348.383.007.984,0,1.968-.007,2.952,0,.171,0,.342,0,.513H39.11c0-.191-.005-.392,0-.594.053-1.695.018-3.4.182-5.081a19.71,19.71,0,0,1,3.4-9.29,17.075,17.075,0,0,1,9.556-7.184c6.264-1.765,11.856-.2,16.644,4.649a19.506,19.506,0,0,1,5.435,11.493c.253,1.965.2,3.979.3,6.008",
    transform: "translate(-27.595 -20.401)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4649",
    "data-name": "Trac\\xE9 4649",
    d: "M51.155,117.314q0-2.665,0-5.331a2.162,2.162,0,0,1,2.063-2.328,8.828,8.828,0,0,1,1.819.091,2.117,2.117,0,0,1,1.566,2.185q.006,5.355,0,10.71a2.125,2.125,0,0,1-1.893,2.255,12.1,12.1,0,0,1-1.743-.01,2.122,2.122,0,0,1-1.811-2.193c-.008-1.793,0-3.586,0-5.379",
    transform: "translate(-36.233 -78.18)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4650",
    "data-name": "Trac\\xE9 4650",
    d: "M138.5,117.328q0,2.618,0,5.236a2.146,2.146,0,0,1-2.024,2.361,13.832,13.832,0,0,1-1.489-.007,2.141,2.141,0,0,1-1.937-2.308q0-5.308,0-10.615a2.089,2.089,0,0,1,1.607-2.237,7.085,7.085,0,0,1,2.277.011,2.083,2.083,0,0,1,1.564,2.18c0,1.793,0,3.586,0,5.379",
    transform: "translate(-94.962 -78.195)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4651",
    "data-name": "Trac\\xE9 4651",
    d: "M157.077,121.16c0-1.7.009-3.395-.008-5.092a.692.692,0,0,1,.346-.68,2.065,2.065,0,0,1,3.079,1.982q.017,3.879,0,7.757a2.032,2.032,0,0,1-3.276,1.67c-.1-.076-.133-.327-.134-.5-.009-1.713-.005-3.426-.005-5.14",
    transform: "translate(-112.184 -82.076)",
    fill: "#161615"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4652",
    "data-name": "Trac\\xE9 4652",
    d: "M37.666,121.181c0,1.713-.011,3.427.009,5.14a.63.63,0,0,1-.373.65,2.093,2.093,0,0,1-3.074-2.1c.076-2.5.01-5.013.022-7.519a2.064,2.064,0,0,1,3.093-1.955.662.662,0,0,1,.331.641c-.016,1.713-.007,3.427-.007,5.14",
    transform: "translate(-24.095 -82.079)",
    fill: "#161615"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeadphone);
export default __webpack_public_path__ + "static/media/ic-headphone.aae7a988f54efd3bcd7faaaf8eacd10d.svg";
export { ForwardRef as ReactComponent };